import React from 'react'
import { connect } from 'react-redux'

import './MessageBox.css'
import { IconError, IconThumbUp } from '../../assets/imgs'
import { showMessageBox } from '../../store/actions/system.actions'

class MessageBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      copied: false,
      isMessageMultiline: false,
    }
    this.messageRef = React.createRef()
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateMessageLayout)
    this.updateMessageLayout()
  }

  componentDidUpdate(prevProps) {
    const hasMessageChanged =
      prevProps.msgOk !== this.props.msgOk ||
      prevProps.msgNOk !== this.props.msgNOk ||
      prevProps.showCopyButton !== this.props.showCopyButton

    if (hasMessageChanged) {
      this.updateMessageLayout()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateMessageLayout)
  }

  // ***** Event *****
  onClose = () => {
    this.props.dispatch(showMessageBox(null, null))
  }

  // ***** Event *****
  onCopyMessage = message => {
    navigator.clipboard
      .writeText(message)
      .then(() => {
        this.setState({ copied: true })
        setTimeout(() => {
          this.setState({ copied: false })
        }, 2000)
      })
      .catch(err => {
        console.error('Erro ao copiar mensagem:', err)
      })
  }

  // ***** Helpers *****
  getMessageBoxClassName = boxClassName => {
    if (this.state.isMessageMultiline) {
      return `MessageBox ${boxClassName} MessageBoxTopAligned`
    }
    return `MessageBox ${boxClassName}`
  }

  updateMessageLayout = () => {
    const messageElement = this.messageRef.current

    if (!messageElement) {
      if (this.state.isMessageMultiline) {
        this.setState({ isMessageMultiline: false })
      }
      return
    }

    const styles = window.getComputedStyle(messageElement)
    const parsedLineHeight = parseFloat(styles.lineHeight)
    const lineHeight = parsedLineHeight || parseFloat(styles.fontSize) * 1.2
    const isMessageMultiline = messageElement.scrollHeight > lineHeight * 1.5

    if (isMessageMultiline !== this.state.isMessageMultiline) {
      this.setState({ isMessageMultiline })
    }
  }

  // ***** Renders *****
  render() {
    const { msgOk, msgNOk, showCopyButton } = this.props
    if (msgOk && msgOk.trim().length > 0) {
      return this._getSuccessBox(msgOk, showCopyButton)
    } else if (msgNOk && msgNOk.trim().length > 0) {
      return this._getErrorBox(msgNOk, showCopyButton)
    } else {
      return null
    }
  }

  // ***** Helpers *****
  _getSuccessBox(msgOk, showCopyButton) {
    setTimeout(() => this.props.dispatch(showMessageBox(null, null)), 4100)
    return (
      <div className={this.getMessageBoxClassName('BoxSuccess')}>
        <img className="StatusIcon" src={IconThumbUp} alt="OK" />
        <span ref={this.messageRef} className="MessageText">
          {msgOk}
        </span>
        {showCopyButton && (
          <div
            className={`CopyButton ${this.state.copied ? 'copied' : ''}`}
            onClick={e => {
              e.stopPropagation()
              this.onCopyMessage(msgOk)
            }}
            title={this.state.copied ? 'Copiado!' : 'Copiar mensagem'}
          >
            <i
              className={`pi ${this.state.copied ? 'pi-check' : 'pi-copy'}`}
              style={{ fontSize: '1rem' }}
            ></i>
          </div>
        )}
      </div>
    )
  }
  _getErrorBox(msgNOk, showCopyButton) {
    return (
      <div className={this.getMessageBoxClassName('BoxError')} onClick={this.onClose}>
        <img className="StatusIcon" src={IconError} alt="Error" />
        <span ref={this.messageRef} className="MessageText">
          {msgNOk}
        </span>
        {showCopyButton && (
          <div
            className={`CopyButton ${this.state.copied ? 'copied' : ''}`}
            onClick={e => {
              e.stopPropagation()
              this.onCopyMessage(msgNOk)
            }}
            title={this.state.copied ? 'Copiado!' : 'Copiar mensagem'}
          >
            <i
              className={`pi ${this.state.copied ? 'pi-check' : 'pi-copy'}`}
              style={{ fontSize: '1rem' }}
            ></i>
          </div>
        )}
        <div className="Close">
          <span className="CloseIcon">&times;</span>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  msgOk: state.system.messageBox.msgOK,
  msgNOk: state.system.messageBox.msgNOK,
  showCopyButton: state.system.messageBox.showCopyButton || false,
})

export default connect(mapStateToProps)(MessageBox)
